<div class="marker">
  <div class="marker__content">
    <svg viewBox="0 0 24 35" fill="none" xmlns="http://www.w3.org/2000/svg" class="marker__svg">
      <path d="M12 34.8621L21.8396 19.8621H2.14746L12 34.8621Z" [attr.fill]="color()"/>
      <path d="M24 12.8621C24 19.4895 18.6274 24.8621 12 24.8621C5.37258 24.8621 0 19.4895 0 12.8621C0 6.23464 5.37258 0.862061 12 0.862061C18.6274 0.862061 24 6.23464 24 12.8621Z" [attr.fill]="color()"/>
    </svg>

    <vdo-icon
      class="marker__icon"
      [svgIcon]="icon()"
      [height]="20"
      [width]="20">
    </vdo-icon>
  </div>
</div>
